module.exports = __webpack_public_path__ + "img/korea.858378c9.jpg";